
















































































































































































































































































//=============================================================================
// 入金管理
//=============================================================================
import Component, { mixins } from "vue-class-component";
import { State, namespace } from "vuex-class";
import AxiosMixin from "@/mixins/axiosMixin";
import { HeaderWidthItem } from "@/types";
import TextMonthChangePicker from "../components/common/TextMonthChangePicker.vue";
import { YearmonthState, SET_YEARMONTH } from "@/store/modules/yearmonth/types";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import NumberInput from "@/components/common/NumberInput.vue";
import { PulldownItem } from "@/types";
import { Watch, Inject, Ref } from "vue-property-decorator";
import VueRouter from "vue-router";
import { ShowSnackbar } from "@/store/modules/showSnackbar/types";
import SelectFilter, { ColumnKey } from "@/components/common/SelectFilter.vue";
import { getDefaultMonth } from "@/types";

const StoreYearmonth = namespace("yearmonth");
Component.registerHooks(["beforeRouteLeave"]);

interface StringKeyObject {
  [key: string]: object;
}

//入金情報（合計）
interface TotalItem {
  prev_balance: number;
  invoice_amt: number;
  payment_amt: number;
  balance: number;
}

//入金情報（利用者別）
interface TableItem {
  patient_id: number;
  ibow_id: string;
  patient_name: string;
  furigana: string;
  payment_method: string;
  prev_balance: number;
  invoice_amt: number;
  drawal_amt: number;
  drawal_result: string;
  trans_amt: number;
  collect_amt: number;
  balance: number;
  selected: boolean;
}

//入金情報（詳細）
interface PayItem {
  id: number;
  office_id: number;
  yearmonth: string;
  patient_id: number;
  payment_div: number;
  payment_amount: number;
  payment_date: string | null;
  remarks: string;
  created_at: string | null;
  updated_at: string | null;
  deleted_at: string | null;
}

interface PaymentManageHeaderItem extends HeaderWidthItem {
  align: string;
}

@Component({
  components: {
    TextMonthChangePicker,
    LoadingDialog,
    EditDayChangePicker,
    NumberInput,
    SelectFilter
  }
})
export default class PaymentManage extends mixins(AxiosMixin) {
  @Ref("selectFilter") private readonly selectFilter!: SelectFilter;
  @State("showsnackbar") snack!: ShowSnackbar;

  @State("yearmonth") yearmonthState!: YearmonthState;
  @StoreYearmonth.Mutation(SET_YEARMONTH) setYearmonth!: Function;

  @Inject() readonly navigationManage!: Function;

  //=================================================================
  // 変数宣言
  //=================================================================

  //結果ファイル取込ダイアログ
  private isFileSelectActive = false;
  //取込結果表示ダイアログ
  private resultDialog = false;
  //取込結果
  private resultMsg = "";
  //取込ファイル
  private fileBank: Blob | null = null;

  //---------------------------------------------
  // 月度合計情報
  //---------------------------------------------
  //月度合計ヘッダ
  private summaryHeader: object[] = [
    { width: "80px", align: "center", value: "prev_balance", text: "前月残高" },
    { width: "80px", align: "center", value: "invoice_amt", text: "請求金額" },
    { width: "80px", align: "center", value: "payment_amt", text: "入金額" },
    { width: "80px", align: "center", value: "balance", text: "差引残高" }
  ];

  //月度合計データ
  private paymentTotal: TotalItem[] = [
    { prev_balance: 0, invoice_amt: 0, payment_amt: 0, balance: 0 }
  ];

  //---------------------------------------------
  // 利用者残高
  //---------------------------------------------
  private sortBy: string[] = [];
  private sortDesc: boolean[] = [];
  //利用者残高ヘッダ
  private patientHeader: PaymentManageHeaderItem[] = [
    {
      width: "98px",
      align: "left",
      value: "ibow_id",
      text: "利用者ID",
      filter: (val: object) => this.columnFilter("ibow_id", val)
    },
    {
      width: "120px",
      align: "left",
      value: "patient_name",
      text: "氏名",
      filter: (val: object) => this.columnFilter("patient_name", val)
    },
    {
      width: "120px",
      align: "left",
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      filter: (val: object) => this.columnFilter("furigana", val)
    },
    {
      width: "100px",
      align: "left",
      value: "payment_method",
      text: "支払方法",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("payment_method", val)
    },
    {
      width: "120px",
      align: "right",
      value: "prev_balance",
      text: "前月残高",
      filterType: SelectFilter.FILTER_TYPE_NUMBER,
      filter: (val: object) => this.columnFilter("prev_balance", val)
    },
    {
      width: "120px",
      align: "right",
      value: "invoice_amt",
      text: "請求金額",
      filterType: SelectFilter.FILTER_TYPE_NUMBER,
      filter: (val: object) => this.columnFilter("invoice_amt", val)
    },
    {
      width: "120px",
      align: "right",
      value: "drawal_amt",
      text: "引落",
      filterType: SelectFilter.FILTER_TYPE_NUMBER,
      filter: (val: object) => this.columnFilter("drawal_amt", val)
    },
    {
      width: "120px",
      align: "right",
      value: "trans_amt",
      text: "振込",
      filterType: SelectFilter.FILTER_TYPE_NUMBER,
      filter: (val: object) => this.columnFilter("trans_amt", val)
    },
    {
      width: "120px",
      align: "right",
      value: "collect_amt",
      text: "集金",
      filterType: SelectFilter.FILTER_TYPE_NUMBER,
      filter: (val: object) => this.columnFilter("collect_amt", val)
    },
    {
      width: "120px",
      align: "right",
      value: "balance",
      text: "差引残高",
      filterType: SelectFilter.FILTER_TYPE_NUMBER,
      filter: (val: object) => this.columnFilter("balance", val)
    }
  ];

  //利用者残高データ
  private tableItems: TableItem[] = [];

  //=================================================================
  // データテーブルのスタイル用
  //=================================================================
  private isTableScroll = false;
  private conditionHeight = 330;

  //---------------------------------------------
  // 入金情報
  //---------------------------------------------
  private isEdit = false;

  //対象の入金情報
  private payItems: PayItem[] = [];
  //対象の入金情報削除リスト
  private delPayItems: PayItem[] = [];

  //入金入力画面表示状態
  private isInput = false;

  //選択行
  private select_row: TableItem = {
    patient_id: 0,
    ibow_id: "",
    patient_name: "",
    furigana: "",
    payment_method: "",
    prev_balance: 0,
    invoice_amt: 0,
    drawal_amt: 0,
    drawal_result: "0",
    trans_amt: 0,
    collect_amt: 0,
    balance: 0,
    selected: false
  };
  private select_row_idx = 0;

  // リサイズ中判定フラグ
  private isResizing = false;

  //入金種別
  private pay_type_items: PulldownItem[] = [
    { text: "", value: 0 },
    { text: "振込", value: 1 },
    { text: "集金", value: 2 }
  ];

  //=================================================================
  // プロパティ
  //=================================================================
  //対象年月
  private get yearmonth() {
    return this.yearmonthState.yearmonth;
  }
  private set yearmonth(yearmonth: string) {
    localStorage.setItem("yearmonth", yearmonth);
    this.setYearmonth(yearmonth);
  }
  private get styles() {
    // console.log('style', this.conditionHeight)
    return {
      "--condition-height": `${this.conditionHeight}px`
    };
  }

  //=================================================================
  // 監視
  //=================================================================
  @Watch("sortBy")
  sortData() {
    this.search();
  }
  @Watch("sortDesc")
  sortOrder() {
    this.search();
  }

  //=================================================================
  // メソッド
  //=================================================================
  mounted() {
    // リサイズイベント登録
    window.onresize = () => {
      this.onresize();
    };
    // トランジッション完了イベント登録
    document.ontransitionend = () => {
      this.onresize();
    };

    const ym = localStorage.getItem("yearmonth");
    this.yearmonth = ym ? String(ym) : getDefaultMonth().substr(0, 7);
    // 画面復帰設定（フィルタ条件）
    if (!this.$route.query.st) {
      this.selectFilter.clearAll();
    } else {
      this.selectFilter.restoreStorage();
    }

    this.search();
  }

  beforeDestroy() {
    window.onresize = null;
    document.ontransitionend = null;
  }

  //画面遷移
  private beforeRouteLeave(to: VueRouter, from: VueRouter, next: Function) {
    if (this.isEdit) {
      if (!confirm("入力した入金情報が保存されていません。よろしいですか？")) {
        // this.$nextTick(() => {
        //  this.navigationManage();
        // });
        next(false);
        return;
      }
    }
    next();
  }

  //---------------------------------------------
  //入金入力閉じる
  //---------------------------------------------
  private closePay() {
    //変更確認
    if (this.isEdit) {
      if (!confirm("入力した入金情報が保存されていません。よろしいですか？")) {
        return;
      }
    }

    this.isInput = false;
    this.isEdit = false;
    this.select_row.selected = false;
  }

  //---------------------------------------------
  //入金情報保存
  //---------------------------------------------
  private savePay() {
    const postItems: PayItem[] = [];
    //チェック
    //全項目入力されているか
    for (let i = 0; i < this.payItems.length; i++) {
      if (
        this.payItems[i].id == 0 &&
        this.payItems[i].payment_date == null &&
        this.payItems[i].payment_div == 0 &&
        this.payItems[i].payment_amount == 0
      ) {
        //新規追加で全て未入力の場合は処理しない。
        continue;
      }
      if (this.payItems[i].payment_date == null) {
        alert("入金日の入力がありません。");
        return;
      }
      if (this.payItems[i].payment_div == 0) {
        alert("方法の入力がありません。");
        return;
      }
      if (this.payItems[i].payment_amount == 0) {
        alert("入金額の入力がありません。");
        return;
      }
      postItems.push(this.payItems[i]);
    }

    //対象が無い場合は終了
    if (postItems.length == 0 && this.delPayItems.length == 0) {
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/office/paymentmanage/savepay",
      {
        save_items: postItems.map((item: PayItem) => {
          return this.itemDataISOString(item);
        }),
        del_items: this.delPayItems.map((item: PayItem) => {
          return this.itemDataISOString(item);
        }),
        patient_id: this.select_row.patient_id,
        patient_name: this.select_row.patient_name
      },
      res => {
        res.data.lists.map(function(item: PayItem) {
          if (item.payment_date) {
            item.payment_date = item.payment_date.substring(0, 10);
          }
          return item;
        });
        this.payItems = res.data.lists;
        //表示選択行データ更新（差分計算）
        this.paymentTotal[0].payment_amt += res.data.diff_amt;
        this.paymentTotal[0].balance -= res.data.diff_amt;
        this.select_row.trans_amt = res.data.trans_amt;
        this.select_row.collect_amt = res.data.collect_amt;
        this.select_row.balance -= res.data.diff_amt;
        this.isEdit = false;
        this.snack.message = "保存しました。";
        this.snack.showSnackbar = true;
      }
    );
  }
  private itemDataISOString(item: PayItem) {
    return {
      id: item.id,
      office_id: item.office_id,
      yearmonth: item.yearmonth,
      patient_id: item.patient_id,
      payment_div: item.payment_div,
      payment_amount: item.payment_amount,
      payment_date: item.payment_date
        ? new Date(item.payment_date).toISOString()
        : null,
      remarks: item.remarks,
      created_at: item.created_at,
      updated_at: item.updated_at,
      deleted_at: item.deleted_at
    };
  }

  //---------------------------------------------
  //入金情報追加
  //---------------------------------------------
  private addLine() {
    this.payItems.unshift({
      id: 0,
      office_id: 0,
      yearmonth: this.yearmonth.replace("-", ""),
      patient_id: this.select_row.patient_id,
      payment_div: 0,
      payment_amount: 0,
      payment_date: null,
      remarks: "",
      created_at: null,
      updated_at: null,
      deleted_at: null
    });
  }

  //---------------------------------------------
  //入金情報削除
  //---------------------------------------------
  private delLine(index: number) {
    if (this.payItems[index].id != 0) {
      this.delPayItems.push(this.payItems[index]);
      this.isEdit = true;
    }
    this.payItems.splice(index, 1);
  }

  //---------------------------------------------
  //行選択
  //---------------------------------------------
  private clickRow(row: TableItem) {
    if (row.selected) {
      //選択済み行の場合はなにもしない
      return;
    }

    //変更確認
    if (this.isEdit) {
      if (!confirm("入力した入金情報が保存されていません。よろしいですか？")) {
        return;
      }
    }

    //選択解除
    this.select_row.selected = false;
    //行選択
    row.selected = true;
    this.isEdit = false;
    for (let i = 0; this.tableItems.length; i++) {
      if (this.tableItems[i].patient_id == row.patient_id) {
        this.select_row_idx = i;
        break;
      }
    }

    this.postJsonCheck(
      window.base_url + "/api/office/paymentmanage/getpay",
      {
        yearmonth: this.yearmonth.replace("-", ""),
        patient_id: row.patient_id,
        patient_name: row.patient_name
      },
      res => {
        res.data.lists.map(function(item: PayItem) {
          if (item.payment_date) {
            item.payment_date = item.payment_date.substring(0, 10);
          }
          return item;
        });
        this.payItems = res.data.lists;
        this.delPayItems = [];
        this.select_row = row;
        this.isInput = true;
      }
    );
  }
  private datatable: HTMLElement | null = null;
  private activeItem: HTMLElement | null = null;
  //行選択した時にテーブルをスクロールさせる処理
  private dataTableScroll(diff: number) {
    this.activeItem = document.getElementsByClassName(
      "itemselect"
    )?.[0] as HTMLElement | null;
    let offsetTop = 0;
    if (this.activeItem) {
      offsetTop = this.activeItem.offsetTop - diff;
    }
    this.datatable = document.getElementById("data-table");
    if (this.datatable) {
      const datatableWrapper: HTMLElement | null = this.datatable
        .firstElementChild as HTMLElement | null;
      if (datatableWrapper) {
        datatableWrapper.scrollTo(0, offsetTop);
      }
    }
  }
  //行選択前
  private prevData() {
    this.clickRow(this.tableItems[this.select_row_idx - 1]);
    this.dataTableScroll(96);
  }
  //行選択次
  private nextData() {
    this.clickRow(this.tableItems[this.select_row_idx + 1]);
    this.dataTableScroll(0);
  }
  //選択行色変更
  private itemClass(item: TableItem) {
    if (item.selected) {
      return "itemselect";
    }
  }

  //---------------------------------------------
  //検索処理
  //---------------------------------------------
  private search() {
    //変更確認
    if (this.isEdit) {
      if (!confirm("入力した入金情報が保存されていません。よろしいですか？")) {
        return;
      }
    }

    this.isInput = false;
    this.isEdit = false;
    this.postJsonCheck(
      window.base_url + "/api/office/paymentmanage/get",
      {
        yearmonth: this.yearmonth.replace("-", ""),
        sort_by: this.sortBy,
        sort_desc: this.sortDesc
      },
      res => {
        this.tableItems = res.data.lists;
        this.paymentTotal = res.data.total;
        this.$router.replace(`/payment_manage?st=1`).catch(err => err);

        this.$nextTick(() => {
          this.onresize();
        });
      }
    );
  }

  //---------------------------------------------
  //引落結果取込
  //---------------------------------------------
  //引落結果取込ダイアログ表示
  private openImportDialog() {
    //変更確認
    if (this.isEdit) {
      if (!confirm("入力した入金情報が保存されていません。よろしいですか？")) {
        return;
      }
    }
    this.isInput = false;
    this.isEdit = false;
    this.select_row.selected = false;
    this.isFileSelectActive = true;
  }
  //引落結果取込ダイアログ閉じる
  private closeImportDialog() {
    this.resultDialog = false;
    this.search();
  }
  //取込処理
  private importResult() {
    if (!this.fileBank) {
      alert("引落結果ファイルが選択されていません。");
      return;
    }
    if (
      !confirm(
        this.yearmonth.replace("-", "年") +
          "月に引落結果を取り込みます。よろしいですか？"
      )
    ) {
      return;
    }
    const formData = new FormData();
    formData.append("yearmonth", this.yearmonth.replace("-", ""));
    formData.append("uploadfile", this.fileBank);
    this.postForm(
      window.base_url + "/api/office/paymentmanage/impbank",
      formData,
      response => {
        if (response.data.code != 0) {
          alert(response.data.message);
          return;
        }
        this.isFileSelectActive = false;
        this.resultMsg = response.data.result_text;
        this.resultDialog = true;
      }
    );
  }

  //---------------------------------------------
  //引落結果一括削除
  //---------------------------------------------
  private deleteImport() {
    if (this.isEdit) {
      if (!confirm("入力した入金情報が保存されていません。よろしいですか？")) {
        return;
      }
    }
    this.isInput = false;
    this.isEdit = false;
    this.select_row.selected = false;

    if (
      !confirm(
        this.yearmonth.replace("-", "年") +
          "月の全利用者の引落結果を削除します。よろしいですか？"
      )
    ) {
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/office/paymentmanage/delbank",
      {
        yearmonth: this.yearmonth.replace("-", ""),
        sort_by: this.sortBy,
        sort_desc: this.sortDesc
      },
      res => {
        this.tableItems = res.data.lists;
        this.paymentTotal = res.data.total;
        this.snack.message = "削除しました。";
        this.snack.showSnackbar = true;
        this.$router.replace(`/payment_manage`).catch(err => err);
        this.$nextTick(() => {
          this.onresize();
        });
      }
    );
  }

  //---------------------------------------------
  //エクセルダウンロード
  //---------------------------------------------
  private downloadExcel() {
    const param = {
      items: this.tableItems
    };
    const fname = `入金管理_${this.yearmonth}.xlsx`;
    this.postJsonBlobRes(
      window.base_url + "/api/office/paymentmanage/excel",
      param,
      res => {
        const blob = new Blob([res.data]);
        const a = document.createElement("a");
        a.download = fname;
        a.href = URL.createObjectURL(blob);
        a.click();
      }
    );
  }

  //---------------------------------------------
  //取込結果ダウンロード
  //---------------------------------------------
  private downloadResult() {
    const blob = new Blob([this.resultMsg]);
    const a = document.createElement("a");
    a.download = `取込結果${this.yearmonth}.txt`;
    a.href = URL.createObjectURL(blob);
    a.click();
  }

  //data tableでソートさせない（サーバ側でソートさせるため）
  private customSort(items: TableItem[]) {
    return items;
  }

  //---------------------------------------------
  //リサイズイベント
  //---------------------------------------------
  private onresize() {
    if (this.isResizing) {
      return;
    }
    this.isResizing = true;

    const conditionArea = document.getElementById(
      "condition-area"
    ) as HTMLElement | null;
    if (conditionArea) {
      // console.log('onresize', this.conditionHeight, conditionArea.clientHeight, window.innerWidth)
      if (this.conditionHeight !== conditionArea.clientHeight) {
        this.conditionHeight = conditionArea.clientHeight;
      }
    } else {
      this.conditionHeight = 330;
    }

    // データテーブルのスタイル切り替え
    const dataTable = document.getElementById(
      "data-table"
    ) as HTMLElement | null;
    if (dataTable) {
      const table = dataTable.children[0].children[0] as HTMLElement | null;
      if (table) {
        if (dataTable.offsetHeight >= table.offsetHeight) {
          // 成り行き
          const root = document.getElementById("root") as HTMLElement | null;
          if (dataTable && root) {
            const dr = dataTable.getBoundingClientRect();
            const rr = root.getBoundingClientRect();
            // console.log('rect', dr, rr)
            // テーブルbottom margin分プラス
            if (rr.bottom < dr.bottom + 4) {
              this.isTableScroll = true;
            } else {
              this.isTableScroll = false;
            }
          }
        } else {
          // スクロール
          this.isTableScroll = true;
        }
      }
    }
    this.isResizing = false;
  }

  //------------------------------------------
  // SelectFilterの選択肢
  //------------------------------------------
  private get columnKeys(): ColumnKey[] {
    return this.patientHeader
      .filter(hditm => {
        return hditm.filter != null;
      })
      .map(hditm => {
        let type = SelectFilter.FILTER_TYPE_EDIT;
        if (hditm.filterType != null) {
          type = hditm.filterType;
        }
        let selectable = null;
        if (
          hditm.filterType === SelectFilter.FILTER_TYPE_LIST ||
          hditm.filterType === SelectFilter.FILTER_TYPE_EDIT_LIST
        ) {
          //選択肢一覧作成
          selectable = this.tableItems
            .map(itm => {
              const txt = (itm as any)[hditm.value];
              return txt === "" ? SelectFilter.NO_DATA : txt;
            })
            .filter((val, idx, arr) => {
              return arr.indexOf(val) === idx;
            });
          //NO_DATAラベルを一覧の先頭に移動
          const idx = selectable.indexOf(SelectFilter.NO_DATA);
          if (idx > 0) {
            this.moveAt(selectable, idx, 0);
          }
        }
        const fkey: ColumnKey = {
          type: type,
          key: hditm.value,
          text: hditm.text,
          selectable: selectable
        };
        return fkey;
      });
  }

  //------------------------------------------
  // カラムフィルター
  //------------------------------------------
  private columnFilter(key: string, val: object) {
    const bret = this.selectFilter.isMatch(key, val);

    // テーブル更新
    if (this.datatable) {
      this.$nextTick(() => {
        this.onresize();
      });
    }
    return bret;
  }

  //------------------------------------------
  // 配列要素の移動
  //------------------------------------------
  private moveAt(array: object[], idx: number, at: number) {
    if (idx === at || idx > array.length - 1 || at > array.length - 1) {
      return;
    }
    const value = array[idx];
    const tail = array.slice(idx + 1);
    array.splice(idx);
    Array.prototype.push.apply(array, tail);
    array.splice(at, 0, value);
  }
}
